import {useParams} from "react-router-dom";
import {useMemo} from "react";

export function useSessionListenUrl() {
    const { sessionUuid } = useParams<{ sessionUuid: string }>();

    return useMemo(
        () => `${process.env.REACT_APP_APP_URL}/panel/sessions/${sessionUuid}/listen`,
        [sessionUuid],
    );
}
